<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title>Entrega</ion-title>

        <ion-button title="fechar" style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end"
            (click)="Close($event)">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>

    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">

    <ion-grid class="full ion-no-margin ion-no-padding">

        <ion-row>


            <ion-col>
                <ion-card class="ion-no-margin full">

                    <ion-card-content>

                        <form [formGroup]="Form">

                            <ion-row>
                                <ion-col size="12">
                                    <ion-item class="full" lines="full">
                                        <ion-label position="stacked" i18n=":@@consumer_form.representative"
                                            [attr.required]="IsFormControlRequired(Form.get('Name'))">Nome
                                        </ion-label>
                                        <ion-input formControlName="Name"></ion-input>
                                    </ion-item>
                                    <form-errors [control]="Form.get('Name')"></form-errors>
                                </ion-col>


                                <ion-col size="12" sizeMd="9">
                                    <ion-item class="full" lines="full">
                                        <ion-label position="stacked" i18n=":@@consumer_form.email"
                                            [attr.required]="IsFormControlRequired(Form.get('Email'))">Email
                                        </ion-label>
                                        <ion-input formControlName="Email"></ion-input>
                                    </ion-item>
                                    <form-errors [control]="Form.get('Email')"></form-errors>
                                </ion-col>
                                <ion-col size="12" sizeMd="3">
                                    <ion-item class="full" lines="full">
                                        <ion-label position="stacked" i18n=":@@consumer_form.mobilephone"
                                            [attr.required]="IsFormControlRequired(Form.get('MobilePhone'))">Nº
                                            Telemóvel
                                        </ion-label>
                                        <ion-input formControlName="MobilePhone"></ion-input>
                                    </ion-item>
                                    <form-errors [control]="Form.get('MobilePhone')"></form-errors>
                                </ion-col>

                                <ion-col size="12" sizeMd="4">
                                    <ion-item class="full" lines="full">
                                        <ion-label position="stacked" i18n=":@@consumer_form.nif"
                                            [attr.required]="IsFormControlRequired(Form.get('VatNumber'))">NIF
                                        </ion-label>
                                        <ion-input formControlName="VatNumber"></ion-input>
                                    </ion-item>
                                    <form-errors [control]="Form.get('VatNumber')"></form-errors>
                                </ion-col>

                                <ion-col size="12" sizeMd="4">

                                    <ion-item class="full" lines="none" fill="outline">
                                        <ion-label position="stacked" i18n=":@@consumer_form.birthday"
                                            [attr.required]="IsFormControlRequired(Form.get('BirthDate'))">Data
                                            nascimento
                                        </ion-label>

                                        <ion-input [id]="'datepicker-movement-crud-dateBirthday'"
                                            [disabled]="Form.get('BirthDate').disabled" inputmode="none"
                                            [value]="(Form.get('BirthDate').value|date:'dd-MM-yyyy')" button readonly>
                                            <ion-icon slot="end" name="calendar-outline"></ion-icon>
                                        </ion-input>

                                        <ion-popover [trigger]="'datepicker-movement-crud-dateBirthday'"
                                            show-backdrop="false">
                                            <ng-template>
                                                <ion-datetime presentation="date" locale="pt" mode="md"
                                                    formControlName="BirthDate" [showDefaultButtons]="false">
                                                </ion-datetime>
                                            </ng-template>
                                        </ion-popover>

                                    </ion-item>

                                    <form-errors [control]="Form.get('BirthDate')"></form-errors>
                                </ion-col>

                                <ion-col size="12" sizeMd="4">
                                    <ion-item class="full" lines="full" fill="outline">
                                        <ion-label position="stacked" i18n=":@@consumer_form.physical_card_required"
                                            [attr.required]="IsFormControlRequired(Form.get('ClaimCardId'))">Entrega
                                            do Vale ({{AvailableCards?.length||'--'}})
                                        </ion-label>

                                        <ion-select [interface]="'popover'" class="outline"
                                            formControlName="ClaimCardId">
                                            <ng-container *ngFor="let item of AvailableCards">
                                                <ion-select-option
                                                    [value]="item?.Id">{{item?.Number||'--'}}</ion-select-option>
                                            </ng-container>
                                        </ion-select>


                                    </ion-item>

                                    <form-errors [control]="Form.get('ClaimCardId')"></form-errors>
                                </ion-col>

                                <ion-col size="12" sizeMd="6">
                                    <ion-item class="full" lines="full" fill="outline">
                                        <ion-label position="stacked" i18n=":@@consumer_form.docNumber"
                                            [attr.required]="IsFormControlRequired(Form.get('IdentificationDocumentNumber'))">Documento
                                            de identificação
                                        </ion-label>

                                        <ion-grid class="full">
                                            <ion-row>
                                                <ion-col style="max-width: 160px;">
                                                    <ion-select [interface]="'popover'" class="outline"
                                                        formControlName="IdDocumentType"
                                                        style="max-width: calc(100% - 12px);">
                                                        <ion-select-option
                                                            [value]="ConsumerDocumentType.BI">BI</ion-select-option>
                                                        <ion-select-option
                                                            [value]="ConsumerDocumentType.CC">CC</ion-select-option>
                                                        <ion-select-option
                                                            [value]="ConsumerDocumentType.PASSPORT">Passaporte</ion-select-option>
                                                        <!-- <ion-select-option value="other">Outro</ion-select-option> -->
                                                    </ion-select>
                                                </ion-col>
                                                <ion-col>
                                                    <ion-input
                                                        formControlName="IdentificationDocumentNumber"></ion-input>
                                                </ion-col>
                                            </ion-row>
                                        </ion-grid>

                                    </ion-item>

                                    <form-errors [control]="Form.get('IdentificationDocumentNumber')"></form-errors>
                                </ion-col>

                                <ion-col size="12" sizeMd="6">
                                    <ion-item class="full" lines="none" fill="outline">
                                        <ion-label position="stacked" i18n=":@@consumer_form.docNumberDate"
                                            [attr.required]="IsFormControlRequired(Form.get('IdentificationDocumentValidityDate'))">Validade
                                            do Documento
                                        </ion-label>
                                        <ion-input [id]="'datepicker-movement-crud-dateEmission'"
                                            [disabled]="Form.get('IdentificationDocumentValidityDate').disabled"
                                            inputmode="none"
                                            [value]="(Form.get('IdentificationDocumentValidityDate').value|date:'dd-MM-yyyy')"
                                            button readonly>
                                            <ion-icon slot="end" name="calendar-outline"></ion-icon>
                                        </ion-input>

                                        <ion-popover [trigger]="'datepicker-movement-crud-dateEmission'"
                                            show-backdrop="false">
                                            <ng-template>
                                                <ion-datetime presentation="date" locale="pt" mode="md"
                                                    [min]="MinValidityDate" [max]="MaxValidityDate"
                                                    formControlName="IdentificationDocumentValidityDate"
                                                    [showDefaultButtons]="false">
                                                </ion-datetime>
                                            </ng-template>
                                        </ion-popover>

                                    </ion-item>
                                    <form-errors
                                        [control]="Form.get('IdentificationDocumentValidityDate')"></form-errors>
                                </ion-col>

                            </ion-row>

                            <ion-row formGroupName="Location">
                                <ion-col size="8">
                                    <ion-item class="full" lines="full">
                                        <ion-label position="stacked" i18n=":@@consumer_form.city"
                                            [attr.required]="IsFormControlRequired(Form.get('Location').get('Locality'))">Cidade
                                        </ion-label>
                                        <ion-input formControlName="Locality"></ion-input>
                                    </ion-item>
                                    <form-errors [control]="Form.get('Location').get('Locality')"></form-errors>
                                </ion-col>
                                <ion-col size="4">
                                    <ion-item class="full" lines="full">
                                        <ion-label position="stacked" i18n=":@@consumer_form.postalcode"
                                            [attr.required]="IsFormControlRequired(Form.get('Location').get('ZipCode'))">Código
                                            postal
                                        </ion-label>
                                        <ion-input placeholder="0000-000" formControlName="ZipCode"></ion-input>
                                    </ion-item>
                                    <form-errors [control]="Form.get('Location').get('ZipCode')"></form-errors>
                                </ion-col>
                            </ion-row>

                            <ion-row formGroupName="Location">
                                <ion-col size="12">
                                    <ion-item class="full" lines="full">
                                        <ion-label position="stacked" i18n=":@@consumer_form.address"
                                            [attr.required]="IsFormControlRequired(Form?.get('Location')?.get('Address'))">Morada
                                        </ion-label>
                                        <ion-input formControlName="Address"></ion-input>
                                    </ion-item>
                                </ion-col>
                                <form-errors [control]="Form.get('Location')?.get('Address')"></form-errors>
                            </ion-row>

                            <ng-container *ngIf="false">
                                <ion-row>
                                    <ion-item class="full" lines="full" fill="outline">
                                        <ion-label position="stacked" i18n=":@@consumer_form.file-address-proof"
                                            [attr.required]="IsFormControlRequired(Form.get('IdentityProof'))">
                                            Documento de identificação</ion-label>
                                        <input-browse [disabled]="Form.get('IdentityProof').disabled"
                                            [fileName]="Form.get('IdentityProof').value?.OriginalName"
                                            [fileURL]="Form.get('IdentityProof').value?.Path"
                                            [accept]="'.pdf,.docx,.doc'"
                                            (callback)="OnChangeFile($event, Form.get('IdentityProof'), ConsumerDocumentType.ProofOfIdentity)"></input-browse>
                                        <!-- <em style="padding-top:6px"
                                    i18n=":@@'consumer_form.form_address_proof_text'">Serão considerados válidos
                                    apenas os comprovativos há menos de 12 meses.</em> -->
                                    </ion-item>

                                    <form-errors [control]="Form.get('IdentityProof')"></form-errors>
                                </ion-row>

                                <ion-row>
                                    <ion-item class="full" lines="full" fill="outline">
                                        <ion-label position="stacked" i18n=":@@consumer_form.file-address-proof"
                                            [attr.required]="IsFormControlRequired(Form.get('AddressProof'))">
                                            Certidão de Domicílio Fiscal</ion-label>
                                        <input-browse [disabled]="Form.get('AddressProof').disabled"
                                            [fileName]="Form.get('AddressProof').value?.OriginalName"
                                            [fileURL]="Form.get('AddressProof').value?.Path"
                                            [accept]="'.pdf,.docx,.doc'"
                                            (callback)="OnChangeFile($event, Form.get('AddressProof'), ConsumerDocumentType.ProofOfAddress)"></input-browse>
                                        <!-- <em style="padding-top:6px"
                                        i18n=":@@'consumer_form.form_address_proof_text'">Serão considerados
                                        válidos
                                        apenas as certidões emitidas há menos de 3 meses.</em> -->
                                    </ion-item>

                                    <form-errors [control]="Form.get('AddressProof')"></form-errors>
                                </ion-row>
                            </ng-container>

                            <ion-row>
                                <ion-col size="12">
                                    <ion-item class="full" lines="full" fill="outline"
                                        [ngClass]="{'disabled': Form.get('description')?.disabled}">
                                        <ion-label position="stacked" i18n=":@@Consumer_form.description">Observações
                                        </ion-label>
                                        <text-editor-quill [source]="Form.get('Observations').value"
                                            [disabled]="Form.get('Observations')?.disabled"
                                            (callback)="OnChangeTextQuill($event)">
                                        </text-editor-quill>
                                    </ion-item>

                                    <form-errors [control]="Form.get('tempObservations')"></form-errors>
                                </ion-col>
                            </ion-row>


                        </form>

                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>

    </ion-grid>

</ion-content>
<ion-footer>
    <ion-toolbar class="ion-padding-horizontal">
        <ion-button style="margin-right: -16px;" slot="end" fill="solid" color="medium"
            i18n=":@@modal_configuration_module.submit" (click)="OnSave($event)">Confirmar
        </ion-button>
    </ion-toolbar>
</ion-footer>